export const productFrequencyOptions = ["Daily", "Weekly", "Monthly"] as const;

export type ProductFrequency = (typeof productFrequencyOptions)[number];
export type ProductFrequencyMap = Record<string, ProductFrequency>;

export function normalizeProductFrequency(value: string | undefined): ProductFrequency {
  return productFrequencyOptions.includes(value as ProductFrequency)
    ? value as ProductFrequency
    : "Monthly";
}

export function getProductFrequency(
  frequencies: ProductFrequencyMap | undefined,
  product: string,
  fallback?: string,
) {
  return frequencies?.[product] ?? normalizeProductFrequency(fallback);
}

export function removeProductFrequencies(
  frequencies: ProductFrequencyMap | undefined,
  allowedProducts: string[],
) {
  const allowed = new Set(allowedProducts);
  return Object.fromEntries(
    Object.entries(frequencies ?? {}).filter(([product]) => allowed.has(product)),
  ) as ProductFrequencyMap;
}
